export default function downList(state = [], action) {
  switch (action.type) {
      case 'ADD_DOWN_LIST':
          return action.payload
      default:
          return state  
  }
}